// extracted by mini-css-extract-plugin
export default {"paginationBox":"index_paginationBox_3gqUi","curPage":"index_curPage_isE69","cantClick":"index_cantClick_9N6ni","pageNum":"index_pageNum_huXuo"};